import React, { lazy } from "react";
import PrivateRoute from "PrivateRoutes";
// import { Phonenumbers } from "./components";
// import { FlowDiagram } from './components';
const Phonenumbers = lazy(() => import(/* webpackChunkName: "Phonenumbers" */"./components"));
const FlowDiagram = lazy(() => import(/* webpackChunkName: "FlowDiagram" */'./../Flow/components/FlowDiagram/FlowDiagram'));
const routes = () => [
  <PrivateRoute exact path="/settings/Phonenumbers" component={Phonenumbers} key="/settings/Phonenumbers" />,
  <PrivateRoute
    key="/settings/flowDiagram"
    exact
    path="/settings/flowDiagram"
    component={({ match }) => {
      return (
        <FlowDiagram integrationId="6974388d-01a3-49b2-bac2-594bf1a0683f" />
      );
    }}
  />,
];

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Phonenumbers/routes.js